import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Cppsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";

function Cifelseif(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  

return(
    <div>
     
      <Sides/>
       <Helmet>
 
 <title>if else if in c++ tutorial For Beginners</title>
 <meta name="description" content="if-else if in c++ tutorial for beginners.If else if is used more than two options CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,if else if in c++ tutorial for beginners,programming language,tutorial for begineers,if else,if,else if,c++ programming tutorial for beginners,learn code in free,if else statement ,C++ if-else-if,learn code in free online" />
 <link rel="canonical" href="https://www.codeexampler.com/cpp-if-else-if" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">if else if in c++</h1>
    <div className="first">
        <a href="/cpp-if-else"><Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-switch"><Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
 

<h2 className='headings'>The syntax for if-else if in C++:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-5">if</span>
            <span className="qwerty-3"> (</span>
            <span className="qwerty-10">condition</span>
            <span className="qwerty-3">)</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-7">statement</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
            
            <span className="qwerty-4">else if</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-7">statement</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
            <span className="qwerty-5">else </span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-7">statement</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


<h2 className="mt-4 mh2">If-else-if uses more than two options.
</h2>


<h2 className='headings'>Q-write a program to check a no is positive, negative, or zero?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10"> i</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-3"> "</span>
            <span className="qwerty-5"> enter a no</span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-4">cin</span>
            <span className="qwerty-3"> &#62;&#62;</span>
            <span className="qwerty-10"> i</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">if</span>
            <span className="qwerty-3"> (</span>
            <span className="qwerty-10">i </span>
            <span className="qwerty-3">&#60; </span>
            <span className="qwerty-7">0</span>
            <span className="qwerty-3">)</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-3">" </span>
            <span className="qwerty-10">negative </span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">else </span>
            <span className="qwerty-4">if</span>
            <span className="qwerty-3"> (</span>
            <span className="qwerty-10">i </span>
            <span className="qwerty-3">&#62; </span>
            <span className="qwerty-7">0</span>
            <span className="qwerty-3">)</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-3">" </span>
            <span className="qwerty-10">positive </span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">else </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10"> zero </span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
            <span className="qwerty-5">return </span>
            <span className="qwerty-10">0; </span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code >
              {"\n"}
              <span className="qwerty-4">enter a no </span>
              <span className="qwerty-10">24</span>
              {"\n"}
              {"\n"}{" "}
              <span className="qwerty-10">positive</span>
            
              {"\n"}{"  "}
              </code>{"\n"}</pre>
        </div>
      </div>





<h2 className='headings'>Q-write a program to input the age and print age detail?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10"> age</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-3"> "</span>
            <span className="qwerty-5"> enter</span>
            <span className="qwerty-10"> age</span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">cin</span>
            <span className="qwerty-3"> &#62;&#62;</span>
            <span className="qwerty-10"> age</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">if</span>
            <span className="qwerty-3"> (</span>
            <span className="qwerty-10">age </span>
            <span className="qwerty-3">&#62;</span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-7">60</span>
            <span className="qwerty-3">)</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10"> old man </span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">else </span>
            <span className="qwerty-4">if</span>
            <span className="qwerty-3"> (</span>
            <span className="qwerty-10">age </span>
            <span className="qwerty-3">&#62; </span>
            <span className="qwerty-7">40</span>
            <span className="qwerty-3">)</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-3">" </span>
            <span className="qwerty-10">not old and not young </span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">else </span>
            <span className="qwerty-4">if</span>
            <span className="qwerty-3"> (</span>
            <span className="qwerty-10">age </span>
            <span className="qwerty-3">&#62; </span>
            <span className="qwerty-7">20</span>
            <span className="qwerty-3">)</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-3"> "</span>
            <span className="qwerty-5"> young</span>
            <span className="qwerty-10"> age</span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">else </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10"> child </span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">return </span>
            <span className="qwerty-10">0; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code >
              {"\n"}
              <span className="qwerty-10">enter</span>
              <span className="qwerty-5"> age </span>
              <span className="qwerty-4">24</span>
              {"\n"}
              {"\n"}
              <span className="qwerty-10">young </span>
              <span className="qwerty-4">age</span>
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>






<h2 className='headings'>Q-write a program to find out the maximum within three numbers?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10"> a,b,c</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-3"> "</span>
            <span className="qwerty-10"> Enter</span>
            <span className="qwerty-5"> A </span>
            <span className="qwerty-10">value </span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">cin</span>
            <span className="qwerty-3"> &#62;&#62;</span>
            <span className="qwerty-10"> a</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-3">" </span>
            <span className="qwerty-10">Enter</span>
            <span className="qwerty-5"> B </span>
            <span className="qwerty-10">value </span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">cin</span>
            <span className="qwerty-3"> &#62;&#62;</span>
            <span className="qwerty-10"> b</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{" "}
            
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-3">" </span>
            <span className="qwerty-10">Enter</span>
            <span className="qwerty-5"> C </span>
            <span className="qwerty-10">value </span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">cin</span>
            <span className="qwerty-3"> &#62;&#62;</span>
            <span className="qwerty-10"> c</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-10">if</span>
            <span className="qwerty-3"> (</span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">&#62; </span>
            <span className="qwerty-10">b </span>
            <span className="qwerty-3">&& </span>
            <span className="qwerty-10">a</span>
            <span className="qwerty-3">&#62;</span>
            <span className="qwerty-10">c</span>
            <span className="qwerty-3">)</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10"> Maximum no is </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-3">&#60;&#60;</span>
        
            <span className="qwerty-10"> a</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">else </span>
            <span className="qwerty-10">if</span>
            <span className="qwerty-3"> (</span>
            <span className="qwerty-10">b </span>
            <span className="qwerty-3">&#62; </span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">&& </span>
            <span className="qwerty-10">b </span>
            <span className="qwerty-3">&#62; </span>
            <span className="qwerty-10">c</span>
            <span className="qwerty-3">)</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10"> Maximum no is </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-3">&#60;&#60;</span>

            <span className="qwerty-10"> b</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">else </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10"> Maximum no is </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-3">&#60;&#60;</span>

            <span className="qwerty-10"> c</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">return </span>
            <span className="qwerty-10">0; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
              {"\n"}
              
              <span className="qwerty-10">Enter</span>
              <span className="qwerty-5"> A</span>
              <span className="qwerty-10"> value </span>
              <span className="qwerty-4">2 </span>
              {"\n"}{"  "} {"\n"}
              <span className="qwerty-10">Enter</span>
              <span className="qwerty-5"> B</span>
              <span className="qwerty-10"> value </span>
              <span className="qwerty-4">8 </span>
              {"\n"}{" "} {"\n"}
              <span className="qwerty-10">Enter</span>
              <span className="qwerty-5"> C</span>
              <span className="qwerty-10"> value </span>
              <span className="qwerty-4">4 </span>
              {"\n"}{"  "} {"\n"}
              <span className="qwerty-10">Maximum no is </span>
              <span className="qwerty-4">8 </span>
            
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>


<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/cpp-if-else">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-switch">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Cifelseif;